// namespace (소문자)
export const NAMESPACE = 'common';
// actions
export const GLOBAL_MESSAGE = 'GLOBAL_MESSAGE';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const SHOW_DIALOG = 'SHOW_DIALOG';
export const HIDE_DIALOG = 'HIDE_DIALOG';
export const CALL_DIALOG_OK = 'CALL_DIALOG_OK';
export const CALL_DIALOG_CANCEL = 'CALL_DIALOG_CANCEL';
export const TOGGLE_NAV_DRAWER = 'TOGGLE_NAV_DRAWER';
export const TOGGLE_NAV_MINI = 'TOGGLE_DAV_MINI';
export const FILE_UPLOAD = 'FILE_UPLOAD';
export const SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG =
  'SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG';
export const HIDE_REQUIRED_UPDATE_PASSWORD_DIALOG =
  'HIDE_REQUIRED_UPDATE_PASSWORD_DIALOG';

export const FETCH_APPINFO = 'FETCH_APPINFO';
export const FETCH_SEARCH = 'FETCH_SEARCH';

// mutations
export const SET_APPINFO = 'SET_APPINFO';
export const APPLOADED = 'APPLOADED';
export const SET_LOAD = 'SET_LOAD';
export const SET_LOADING = 'SET_LOADING';
export const PUT_GLOBAL_MESSAGE = 'PUT_GLOBAL_MESSAGE';
export const DELETE_GLOBAL_MESSAGE = 'DELETE_GLOBAL_MESSAGE';
export const FETCH_END = 'FETCH_END';
export const FETCH_START = 'FETCH_START';
export const RESET_STATE = 'RESET_MODULE_STATE';
export const SET_ERROR = 'SET_ERROR';
export const SET_LOADER = 'SET_LOADER';
export const SET_SNACKBAR = 'SET_SNACKBAR';
export const SET_SHOW_SNACKBAR = 'SET_SHOW_SNACKBAR';
export const SET_DIALOG = 'SET_DIALOG';
export const SET_SHOW_DIALOG = 'SET_SHOW_DIALOG';
export const DIALOG_OK = 'DIALOG_OK';
export const DIALOG_CANCEL = 'DIALOG_CANCEL';
export const SET_NAV_DRAWER = 'SET_NAV_DRAWER';
export const SET_NAV_MINI = 'SET_NAV_MINI';
export const SET_REQUIRED_UPDATE_PASSWORD_DIALOG =
  'SET_REQUIRED_UPDATE_PASSWORD_DIALOG';
export const SET_CUSTOM_HEADER_TEXT = 'SET_CUSTOM_HEADER_TEXT';

export const getName = name => `${NAMESPACE}/${name}`;
export const ROOT_APPLOADED = getName(APPLOADED);
export const ROOT_FETCH_APPINFO = getName(FETCH_APPINFO);
export const ROOT_SHOW_LOADING = getName(SHOW_LOADING);
export const ROOT_HIDE_LOADING = getName(HIDE_LOADING);
export const ROOT_SET_SNACKBAR = getName(SET_SNACKBAR);
export const ROOT_SET_APPINFO = getName(SET_APPINFO);
export const ROOT_SET_DIALOG = getName(SET_DIALOG);
export const ROOT_SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG = getName(
  SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG,
);
export const ROOT_HIDE_REQUIRED_UPDATE_PASSWORD_DIALOG = getName(
  HIDE_REQUIRED_UPDATE_PASSWORD_DIALOG,
);
/*
interface NotificationType {
  list: Array<any>;
}
interface NavigationType {
  drawer: boolean;
  mini: boolean;
}
interface SnakbarType {
  showSnackbar: boolean;
  snackbarPosX: string;
  snackbarPosY: string;
  snackbarMessage: string;
  snackbarColor: string;
  snackbarDuration: number;
}
interface DialogType {
  dialogShow: boolean;
  dialogType: string;
  dialogTitle: string;
  dialogMessage: string;
  dialogIcon: any;
  dialogOkCb: Function;
  dialogCancelCb: Function;
}
export interface State {
  error: any;
  isMobile: boolean;
  globalMessage: Array<any>;
  notification: NotificationType;
  loading: boolean;
  appLoaded: boolean;
  showLoader: boolean;
  navigation: NavigationType;
  snakbar: SnakbarType;
  dialog: DialogType;
}*/
